import { Component } from "react";
import { Form, Button, Row, Col } from "react-bootstrap";
import { getCountries } from "../../services/userMandatoryFields";
import {
  USER_DATA,
  IDENTIFY_CASES,
  EDUCATION_ANNUAL_BUDGET,
  TOTAL_BUDGET_ANNUAL,
  LOOKING_FOR,
} from "../../helpers/constants";
import {
  postUserBiographicInformation,
  getUserBiographicInformation,
} from "../../services/userInformation";
import { getCurrentUser } from "../../services/authService";
import UserProfileBanner from "./UserProfileBanner";
import { toast } from "react-toastify";

class UserBiographicInformation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      countryList: [],
      userData: [],
      currentUser: [],
      data: {},
      success: "",
      cases: IDENTIFY_CASES,
      looking_for: LOOKING_FOR,
      beginDate: new Date(),
      education_annual_budget: EDUCATION_ANNUAL_BUDGET,
      getUserBioInfo: {},
      total_budget_annual: TOTAL_BUDGET_ANNUAL,
      userBioInformation: {
        publicId: "",
        looking_for: [],
        countries_interested_first: "",
        countries_interested_second: "",
        countries_interested_third: "",
        identify_cases: "",
        scholarship_with: "",
        education_budget_annual: "",
        total_budget_annual: "",
        contacted_allowed: "",
        scholership_seeking_remarks: "",
      },
    };
    this.getAllCountries = this.getAllCountries.bind(this);
    this.onChange = this.onChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.getCurrentUserInformation = this.getCurrentUserInformation.bind(this);
    this.onCheckboxChange = this.onCheckboxChange.bind(this);
    this.getUserBioInformation = this.getUserBioInformation.bind(this);
  }

  componentDidMount() {
    try {
      let user = JSON.parse(localStorage.getItem(USER_DATA));
      this.getAllCountries();
      this.setState({ userData: user });
      this.setState({
        userBioInformation: {
          ...this.state.userBioInformation,
          publicId: user?.publicId,
        },
      });
      this.getCurrentUserInformation(user?.publicId);
      this.getUserBioInformation(user?.publicId);
      setTimeout(() => {
        this.setState({ success: "" });
      }, 500);
    } catch (error) {
      console.log(error);
    }
  }

  getUserBioInformation(userPublicId) {
    getUserBiographicInformation(userPublicId)
      .then((res) => {
        let looking_services = [];
        if (res?.looking_for !== "") {
          looking_services = res?.looking_for?.split(",");
        } else {
          looking_services = [];
        }
        this.setState({
          userBioInformation: {
            ...res,
            looking_for: looking_services ? looking_services : [],
            publicId: userPublicId,
          },
        });
      })
      .catch((error) => console.log(error));
  }

  async getAllCountries() {
    await getCountries().then((resp) => this.setState({ countryList: resp }));
  }

  getCurrentUserInformation(userPublicId) {
    getCurrentUser(userPublicId)
      .then((response) => {
        if (response) {
          this.setState({ currentUser: response });
        } else {
          console.error(response, "GET USER VERIFIED ERROR");
        }
      })
      .catch((err) => console.log(err));
  }

  onChange(e) {
    let { name, value } = e.target;
    this.setState({
      userBioInformation: { ...this.state.userBioInformation, [name]: value },
    });
  }

  // onCheckboxChange(e) {
  //     let {name, checked, value} = e.target;
  //     if(checked)  {
  //         console.log(this.state.userBioInformation?.looking_for?.length<=3, 'user bio info.')
  //         this.state.userBioInformation?.looking_for.length<3 ?
  //         this.setState({userBioInformation:{...this.state.userBioInformation, [name]:[...this.state.userBioInformation?.looking_for, value]}})
  //         :
  //         toast.error('You can select only 3 items.');
  //     }
  //     else{
  //         let index="";
  //         this.state.userBioInformation.looking_for.map((val,i) => {
  //             if(val===value){
  //                 index=i
  //             }
  //         })
  //         this.state.userBioInformation.looking_for.splice(index,1)
  //         this.setState({userBioInformation:this.state.userBioInformation})
  //     }
  // }
  onCheckboxChange(e) {
    const { name, checked, value } = e.target;
    const { userBioInformation } = this.state;
   console.log( userBioInformation)
    if (checked) {
      console.log(
        userBioInformation?.looking_for?.length <= 3,
        "user bio info."
      );

      if (userBioInformation?.looking_for?.length < 3) {
        this.setState((prevState) => ({
          userBioInformation: {
            ...prevState.userBioInformation,
            looking_for: [
              ...(prevState.userBioInformation?.looking_for || []),
              value,
            ],
          },
        }));
      } else if(userBioInformation?.looking_for?.length < 3){
        toast.error("You can select only 3 items.");
        // this.setState((prevState) => ({
        //     userBioInformation: {
        //       ...prevState.userBioInformation,
        //       looking_for: [
        //         ...(prevState.userBioInformation?.looking_for || []),
        //         value,
        //       ],
        //     },
        //   }));
      }
    } else {
      const index = userBioInformation.looking_for.indexOf(value);
      if (index !== -1) {
        userBioInformation.looking_for.splice(index, 1);
        this.setState({ userBioInformation });
      }
    }
  }

  onSubmit(e) {
    e.preventDefault();
    postUserBiographicInformation(this.state.userBioInformation)
      .then((response) => {
        if (response) {
          this.setState({ success: response?.message });
          if (response?.message === "All fields required") {
            toast.error(`${response?.message}`);
          } else {
            toast.success(`Biographic Information Saved Successfully`);
            setTimeout(() => {
              this.props.history.push("/user-academic-information");
            }, 1000);
          }
        } else {
          toast.error("There is an error, kindly check.");
        }
      })
      .catch((error) => console.log(error, "this is new error"));
  }

  render() {
    return (
      <>
        <UserProfileBanner />
        <div
          className="accordion content-accordion"
          id="UserBiographicInformations"
        >
          <div key="user_biographical_accordion" className="accordion-item">
            <h2 className="accordion-header" id="heading">
              <button
                className="accordion-button accordion-btn collapsed"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#collapse"
                aria-expanded="false"
                aria-controls="collapse"
              >
                Informations Biographiques
              </button>
            </h2>
            <div
              id="collapse"
              className="accordion-collapse collapse show"
              aria-labelledby="heading"
              data-bs-parent="#UserBiographicInformations"
            >
              <div className="accordion-body">
                <Form onSubmit={this.onSubmit}>
                  {}
                  <Row>
                    <Col>
                      <Form.Label className="user-information-label">
                        <strong>
                          1. Quel est le top 3 des informations ou services que
                          vous recherchez?
                        </strong>{" "}
                        (Select top 3 reasons amongst the following)
                      </Form.Label>
                      {this.state.looking_for &&
                        this.state.looking_for.length > 0 &&
                        this.state.looking_for?.map((looking, index) => {
                          return (
                            <Form.Check
                              key={looking?.id}
                              checked={
                                this.state.userBioInformation?.looking_for?.includes(
                                  looking.name
                                )
                                  ? true
                                  : false
                              }
                              name="looking_for"
                              onChange={(e) => this.onCheckboxChange(e)}
                              value={looking?.name}
                              label={looking?.name}
                              className="check-wrap"
                              id={looking?.id}
                            />
                          );
                        })}
                    </Col>
                  </Row>

                  <Row>
                    <Col>
                      <Form.Group>
                        <Form.Label className="d-flex flex-wrap align-items-center justify-content-between user-information-label">
                          2. Quel est le top 3 des pays qui vous intéressent?
                        </Form.Label>
                        <Row>
                          <Col>
                            <Form.Group controlId="countries_interested_first">
                              {this.state.countryList &&
                                this.state.countryList.length > 0 && (
                                  <Form.Control
                                    as="select"
                                    required
                                    custom
                                    onChange={this.onChange}
                                    name="countries_interested_first"
                                    value={
                                      this.state.userBioInformation
                                        ?.countries_interested_first
                                    }
                                  >
                                    {this.state.countryList?.map((country) => (
                                      <option
                                        key={country?.id}
                                        value={country?.id}
                                      >
                                        {country?.name}
                                      </option>
                                    ))}
                                  </Form.Control>
                                )}
                            </Form.Group>
                          </Col>
                          <Col>
                            <Form.Group controlId="countries_interested_second">
                              {this.state.countryList &&
                                this.state.countryList.length > 0 && (
                                  <Form.Control
                                    as="select"
                                    required
                                    custom
                                    onChange={this.onChange}
                                    name="countries_interested_second"
                                    value={
                                      this.state.userBioInformation
                                        ?.countries_interested_second
                                    }
                                  >
                                    {this.state.countryList?.map((country) => (
                                      <option
                                        key={country?.id}
                                        value={country?.id}
                                      >
                                        {country?.name}
                                      </option>
                                    ))}
                                  </Form.Control>
                                )}
                            </Form.Group>
                          </Col>
                          <Col>
                            <Form.Group controlId="countries_interested_third">
                              {this.state.countryList &&
                                this.state.countryList.length > 0 && (
                                  <Form.Control
                                    as="select"
                                    required
                                    custom
                                    onChange={this.onChange}
                                    name="countries_interested_third"
                                    value={
                                      this.state.userBioInformation
                                        ?.countries_interested_third
                                    }
                                  >
                                    {this.state.countryList?.map((country) => (
                                      <option
                                        key={country?.id}
                                        value={country?.id}
                                      >
                                        {country?.name}
                                      </option>
                                    ))}
                                  </Form.Control>
                                )}
                            </Form.Group>
                          </Col>
                        </Row>
                        <Row>
                          <Col xs="12" sm="6">
                            <Form.Label className="user-information-label">
                              Vous identifiez-vous à un des cas suivants:
                            </Form.Label>
                            <Form.Group controlId="identify_cases">
                              {this.state.cases &&
                                this.state.cases.length > 0 && (
                                  <Form.Control
                                    as="select"
                                    required
                                    custom
                                    onChange={this.onChange}
                                    name="identify_cases"
                                    value={
                                      this.state.userBioInformation &&
                                      this.state.userBioInformation
                                        ?.identify_cases
                                    }
                                  >
                                    {this.state.cases?.map((identify_case) => (
                                      <option
                                        key={identify_case?.id}
                                        value={identify_case?.name}
                                      >
                                        {identify_case?.name}
                                      </option>
                                    ))}
                                  </Form.Control>
                                )}
                            </Form.Group>
                          </Col>
                        </Row>
                      </Form.Group>
                    </Col>
                  </Row>

                  <Row>
                    <Col>
                      <Form.Group>
                        <Form.Label className="d-flex flex-wrap align-items-center justify-content-between user-information-label">
                          3. Quel est votre budget annuel pour financer votre
                          scolarité?
                        </Form.Label>
                        <Row>
                          <Col xs="12" sm="6">
                            <Form.Group controlId="education_budget_annual">
                              {this.state.education_annual_budget &&
                                this.state.education_annual_budget.length >
                                  0 && (
                                  <Form.Control
                                    as="select"
                                    required
                                    custom
                                    onChange={this.onChange}
                                    name="education_budget_annual"
                                    value={
                                      this.state.userBioInformation &&
                                      this.state.userBioInformation
                                        ?.education_budget_annual
                                    }
                                  >
                                    {this.state.education_annual_budget?.map(
                                      (education_budget) => (
                                        <option
                                          key={education_budget?.id}
                                          value={education_budget?.budget}
                                        >
                                          {education_budget?.budget}
                                        </option>
                                      )
                                    )}
                                  </Form.Control>
                                )}
                            </Form.Group>
                          </Col>
                        </Row>
                      </Form.Group>
                    </Col>
                  </Row>

                  <Row>
                    <Col>
                      <Form.Group>
                        <Form.Label className="d-flex flex-wrap align-items-center justify-content-between user-information-label">
                          4. Quel est votre budget annuel pour financer vos
                          frais de vie en tant qu'étudiant(e)?
                        </Form.Label>
                        <Row>
                          <Col xs="12" sm="6">
                            <Form.Group controlId="total_budget_annual">
                              {this.state.total_budget_annual &&
                                this.state.total_budget_annual.length > 0 && (
                                  <Form.Control
                                    as="select"
                                    required
                                    custom
                                    onChange={this.onChange}
                                    name="total_budget_annual"
                                    value={
                                      this.state.userBioInformation &&
                                      this.state.userBioInformation
                                        ?.total_budget_annual
                                    }
                                  >
                                    {this.state.total_budget_annual?.map(
                                      (annual_budget) => (
                                        <option
                                          key={annual_budget?.id}
                                          value={annual_budget?.budget}
                                        >
                                          {annual_budget?.budget}
                                        </option>
                                      )
                                    )}
                                  </Form.Control>
                                )}
                            </Form.Group>
                          </Col>
                        </Row>
                      </Form.Group>
                    </Col>
                  </Row>

                  <Row>
                    <Col>
                      <Form.Group controlId="formBasicEmail">
                        <Form.Label className="d-flex flex-wrap align-items-center justify-content-between user-information-label">
                          5. Souhaitez-vous être éventuellement contacté pour
                          des opportunités ou des bourses qui correspondent à
                          votre profil?
                        </Form.Label>
                        <Form.Check
                          checked={
                            this.state.userBioInformation &&
                            this.state.userBioInformation?.contacted_allowed ==
                              "1"
                          }
                          type="radio"
                          label="Oui"
                          value="1"
                          className="radio-wrap"
                          name="contacted_allowed"
                          id="opportunities-yes"
                          onChange={this.onChange}
                        />
                        <Form.Check
                          checked={
                            this.state.userBioInformation &&
                            this.state.userBioInformation?.contacted_allowed ==
                              "0"
                          }
                          type="radio"
                          label="Non"
                          value="0"
                          className="radio-wrap"
                          name="contacted_allowed"
                          id="opportunities-no"
                          onChange={this.onChange}
                        />
                      </Form.Group>
                    </Col>
                  </Row>

                  <Row>
                    <Col>
                      <Form.Group controlId="scholarship_with">
                        <Form.Label className="d-flex flex-wrap align-items-center justify-content-between user-information-label">
                          6. Si vous recherchez une bourse, s'agit-il:
                        </Form.Label>
                        <Form.Check
                          checked={
                            this.state.userBioInformation &&
                            this.state.userBioInformation?.scholarship_with ==
                              "une bourse d’excellence? With explanation"
                          }
                          onChange={this.onChange}
                          type="radio"
                          value="une bourse d’excellence? With explanation"
                          label="une bourse d’excellence? With explanation"
                          className="radio-wrap"
                          name="scholarship_with"
                          id="excellence-scholarship"
                        />
                        <Form.Check
                          checked={
                            this.state.userBioInformation &&
                            this.state.userBioInformation?.scholarship_with ==
                              "une bourse sur critères sociaux? With explanation"
                          }
                          onChange={this.onChange}
                          type="radio"
                          value="une bourse sur critères sociaux? With explanation"
                          label="une bourse sur critères sociaux? With explanation"
                          className="radio-wrap"
                          name="scholarship_with"
                          id="social-criteria"
                        />
                      </Form.Group>
                    </Col>
                  </Row>

                  <Row>
                    <Col>
                      <Form.Group controlId="scholership_seeking_remarks">
                        <Form.Label className="d-flex flex-wrap align-items-center justify-content-between user-information-label">
                          7. Merci de “motiver en 150 mots la raison pour
                          laquelle vous recherchez ce type de bourse.”
                        </Form.Label>
                        <Form.Control
                          as="textarea"
                          rows={4}
                          style={{ resize: "none" }}
                          name="scholership_seeking_remarks"
                          onChange={this.onChange}
                          value={
                            this.state.userBioInformation &&
                            this.state.userBioInformation
                              ?.scholership_seeking_remarks
                          }
                        />
                      </Form.Group>
                    </Col>
                  </Row>

                  <Row>
                    <Col></Col>
                    <Col
                      xs="12"
                      sm={8}
                      className="align-items-end d-flex justify-content-end"
                    >
                      <Button className="btn-user-information" type="submit">
                        Sauver et poursuivre
                      </Button>
                    </Col>
                  </Row>
                </Form>
                {this.state.success !== "" &&
                  this.state.success === "All fields required" && (
                    <div
                      className={`${
                        this.state.success === "All fields required" &&
                        "error-message"
                      }`}
                    >
                      {this.state.success}
                    </div>
                  )}
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}
export default UserBiographicInformation;
